module.exports = __webpack_public_path__ + "img/plexamp.a59487a9.svg";